import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import MobileNav from '../components/MobileNav';
import SearchPopup from '../components/SearchPopup';

const causes = [
  {
    tag: 'Clean Water',
    title: 'Safe water for families and schools',
    text: 'Wells and water filters to protect children from water‑borne illnesses.',
    img: 'assets/images/Hope-Spring-Water-Charity.jpg',
  },
  {
    tag: 'Education',
    title: 'Empowering futures through learning',
    text: 'Scholarships, school meals and supplies to keep children in class.',
    img: 'assets/images/21.jpg',
  },
  {
    tag: 'Healthcare',
    title: 'Access to essential health services',
    text: 'Mobile clinics and essential medicines for vulnerable communities.',
    img: 'assets/images/affordable-healthcare.jpg',
  },
  {
    tag: 'Relief',
    title: 'Rapid response in crises',
    text: 'Emergency kits, clean water and shelter when disasters strike.',
    img: 'assets/images/22.webp',
  },
  {
    tag: 'Nutrition',
    title: 'Ending hunger with dignity',
    text: 'Food baskets and school meals for children and families.',
    img: 'assets/images/1.jpg',
  },
  {
    tag: 'Livelihoods',
    title: 'Helping families rebuild and thrive',
    text: 'Training and tools for long‑term, community‑led solutions.',
    img: 'assets/images/2.jpg',
  },
];

const CauseCard = ({ c, index }) => (
  <div className="col-xl-4 col-lg-4 col-md-6">
    <div className={`causes-one__single ${index === 1 ? 'causes-one__single-2' : ''} ${index === 2 ? 'causes-one__single-3' : ''}`}>
      <div className="causes-one__arrow">
        <a href="#"><span className="icon-right-arrow"></span></a>
      </div>
      <div className="causes-one__img-box">
        <div className="causes-one__img"><img src={c.img} alt={c.title} /></div>
        <div className="causes-one__tag"><span>{c.tag}</span></div>
      </div>
      <div className="causes-one__content">
        <h3 className="causes-one__title"><a href="#">{c.title}</a></h3>
        <p className="causes-one__text">{c.text}</p>
        <div className="causes-one__rised-and-progress">
          <div className="progress-box">
            <div className="inner count-box">
              <div className="bar">
                <div className="bar-inner count-bar" data-percent="86%">
                  <div className="count-text">86%</div>
                </div>
              </div>
            </div>
          </div>
          <div className="causes-one__rised-and-goals">
            <div className="causes-one__raised"><span>₦14,300 Raised</span></div>
            <div className="causes-one__goals"><span>₦28,000 Goal</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const Donations = () => {
  return (
    <>
      <MobileNav />
      <SearchPopup />

      {/* Custom cursors */}
      <div className="custom-cursor__cursor"></div>
      <div className="custom-cursor__cursor-two"></div>

      <div className="page-wrapper">
        <Header />

        {/* Sticky header placeholder */}
        <div className="stricky-header stricked-menu main-menu">
          <div className="sticky-header__content"></div>
        </div>

        {/* Page Header Start */}
        <section className="page-header">
          <div className="page-header__bg" style={{ backgroundImage: 'url(assets/images/5.jpg)' }}></div>
          <div className="page-header__shape-bg" style={{ backgroundImage: 'url(assets/images/shapes/page-header-shape-bg.png)' }}></div>
          <div className="page-header__shape-1 float-bob-x">
            <img src="assets/images/shapes/page-header-shape-1.png" alt="" />
          </div>
          <div className="page-header__shape-2 float-bob-y">
            <img src="assets/images/shapes/page-header-shape-2.png" alt="" />
          </div>
          <div className="container">
            <div className="page-header__inner">
              <h2>Donations</h2>
              <div className="thm-breadcrumb__box">
                <ul className="thm-breadcrumb list-unstyled">
                  <li><a href="/">Home</a></li>
                  <li><span className="fas fa-angle-right"></span></li>
                  <li>Donations</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/* Page Header End */}

        {/* Causes One Start */}
        <section className="causes-one causes-page">
          <div className="container">
            <div className="row">
              {causes.map((c, i) => (
                <CauseCard c={c} index={i} key={i} />
              ))}
            </div>
          </div>
        </section>
        {/* Causes One End */}

        <Footer />
      </div>
    </>
  );
};

export default Donations;
